<script setup lang="ts">
defineProps<{ label: string; hint?: string; error?: string }>();
</script>

<template>
  <label class="eqf">
    <span class="eqf__label">{{ label }}</span>
    <slot />
    <span v-if="error" class="eqf__error" role="alert">{{ error }}</span>
    <span v-else-if="hint" class="eqf__hint">{{ hint }}</span>
  </label>
</template>

<style scoped>
.eqf {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  min-width: 0;
}
.eqf__label {
  font-size: 0.75rem;
  font-weight: 700;
  color: var(--nxt-on-surface-variant);
}
.eqf__hint {
  font-size: 0.75rem;
  color: var(--nxt-on-surface-muted);
}
.eqf__error {
  font-size: 0.75rem;
  color: var(--nxt-error);
}
</style>
